
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import FAQ from "../pages/faq/page";
import Datenschutz from "../pages/datenschutz/page";
import Impressum from "../pages/impressum/page";
import AGB from "../pages/agb/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/faq",
    element: <FAQ />,
  },
  {
    path: "/datenschutz",
    element: <Datenschutz />,
  },
  {
    path: "/impressum",
    element: <Impressum />,
  },
  {
    path: "/agb",
    element: <AGB />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
